/*
 * @Author: 秦少卫
 * @Date: 2024-04-24 14:07:06
 * @LastEditors: 秦少卫 nihaojob@163.com
 * @LastEditTime: 2025-08-09 16:58:37
 * @Description: 用户接口登录
 */

import axios from 'axios';

import strapi, { createInstance } from './strapiClass';
const baseURL = import.meta.env.APP_APIHOST;

const instance = axios.create({ baseURL });
createInstance(instance, true, false, getToken);

const tokenKey = 'token';

function getToken() {
  const token = localStorage.getItem(tokenKey);
  return token;
}
// 详情
export const getUserInfo = (data?: any) => instance.get('/api/users/me', data);

// 登录
export const login = (data: any) => instance.post('/api/auth/local', data);

// 注册
export const register = (data: any) => instance.post('/api/auth/local/register', data);

// 登出
export const logout = () => localStorage.setItem(tokenKey, '');

// 自动登录
export const autoLogin = (data: any) => instance.post('/api/custom/autoAuthUser', data);

// 设置token
export const setToken = (token: string) => localStorage.setItem(tokenKey, token);

// 获取用户树菜单
export const getUserFileTypeTree = () => instance.get(`/api/user-templ/getUerFileTypeTree`);

// 获取菜单树
export const getFileTypeTree = (data: any) =>
  instance.get(`/api/custom/getUerFileTypeTree`, {
    params: data,
  });

// 获取用户树菜单
export const getUerFileTree = () => instance.get(`/api/user-templ/getUerFileTree`);

// 上传素材
export const uploadImg = (data: any) => instance.post('/api/upload', data);

// 用户素材列表
export const userMaterialsApi = new strapi('/api/user-materials', true);
// 用户字体
export const userFontApi = new strapi('/api/userfonts', true);
// 用户模板
export const userTemplApi = new strapi('/api/user-templs', true);

// 图片抠图
export const removeBgApi = new strapi('/api/custom/removeBg', true);

// 生成图片
export const midjourneyApi = new strapi('/api/custom/midjourney', true);

// 查询结果
export const queryMidjourneyJobApi = new strapi('/api/custom/queryMidjourneyJob', true);

// 用户组件
export const userComponentsUrlApi = new strapi('/api/user-components', true);

// 获取充值配置列表
export const payments = () => instance.get('/api/payments');
// 获取当前用户的余额
export const userCoins = () => instance.get('/api/user-coins');
// 发起充值订单
export const createOrder = (data: any) => instance.post('/api/payment/createOrder', data);
// 获取订单详情
export const ordersDetail = (id: string) => instance.get(`/api/orders/${id}`);
// 获取用户订单列表
export const ordersList = (params: any) =>
  instance.get(`/api/orders`, {
    params,
  });
// 余额使用记录
export const userCoinLogs = (params: any) =>
  instance.get('/api/user-coin-logs', {
    params,
  });
// 微信回调
export const wxpayNotify = (data: any) => instance.post('/api/order/wxpay-notify', data);

export const orderListApi = new strapi('/api/orders', true);

// 忘记密码-发送验证码
export const sendCodeToEmail = (data: any) => instance.post('api/auth/forgot-password', data);

// 忘记密码-确认密码
export const confirmPassword = (data: any) => instance.post('api/auth/reset-password', data);

// 用户收藏模版
export const userFavoriteTemplates = new strapi('/api/user-fav-templs', true);

// 用户收藏素材
export const userFavoriteMaterials = new strapi('/api/user-fav-materials', true);
//修改密码
export const changePasswordApi = (data: any) => instance.post('api/auth/change-password', data);

// 新会员
export const vipUserOrderCreateApi = new strapi('/api/vipUser/createOrder', true);

// 获取会员详情
export const getVipInfoApi = () => instance.get('/api/vipUser/getVipInfo');

// 删除会员次数
export const removeVipLength = (data: any) => instance.post('/api/vipUser/removeLength', data);

// 检查会员次数
export const checkVipLengthApi = (data: any) =>
  instance.get('/api/vipUser/checkLength', { params: data });

// 会员检查
export const vipUserCheckApi = () => instance.get('/api/vipUser/checkVip');

// 获取用户地址列表
export const userAddressApi = () => instance.get('/api/user-addresses');

// 创建用户地址
export const createUserAddressApi = (data: any) => instance.post('/api/user-addresses', data);
// 更新用户地址
export const updateUserAddressApi = (id: string, data: any) =>
  instance.put(`/api/user-addresses/${id}`, data);
// 删除用户地址
export const deleteUserAddressApi = (id: string) => instance.delete(`/api/user-addresses/${id}`);
//id获取地址详情
export const getUserAddressByIdApi = async (id: string) =>
  instance.get(`/api/user-addresses/${id}`);

export function uploadApi(key: string, file: File | Blob) {
  return instance.post(`/upload`, file, {
    params: { key },
  });
}
// 上传图片
export const uploadImgApi = new strapi('/api/upload', true);
// // 创建用户购物车
// export const createUserCartApi = (data: any) => instance.post(`/api/user-carts`, data);

// //获取user-cart详情
// export const getUserCartByIdApi = () => instance.get(`/api/user-carts`);

// //更新user-cart
// export const updateUserCartApi = (id: string, data: any) =>
//   instance.put(`/api/user-carts/${id}`, data);

export const userCartApi = new strapi('/api/user-carts', true);
//总价格接口
export const getTotalPriceApi = (data: any) =>
  instance.get(`/api/user-pro-order/getTotalAmount`, {
    params: data,
  });

// 创建商品订单
export const createProOrderApi = (data: any) =>
  instance.post('/api/user-pro-order/createOrder', data);

// 获取商品订单列
export const podOrderListApi = new strapi('/api/user-pro-orders', true);

//添加风格化任务
export const userCreateAIStyleApi = new strapi('api/custom/aiStyle', true);
//获取ai图库任务列表
export const userAIImageApi = new strapi('/api/user-ai-imgs', true);

// 用户店铺
export const userShopApi = new strapi('/api/user-shops', true);
